// eslint-disable-next-line @typescript-eslint/no-require-imports
require('intersection-observer');
